var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_4143)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8a4 4 0 110 8 4 4 0 010-8zm0 1.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5a1 1 0 011 1v12a1 1 0 01-1 1H6l-.103-.005A1 1 0 015 18V6a1 1 0 011-1h17zM6.5 17.5h1.692A2.25 2.25 0 006.5 15.808V17.5zm3.216-11A3.75 3.75 0 016.5 9.716v4.567A3.751 3.751 0 019.716 17.5h9.568a3.751 3.751 0 013.216-3.217V9.716A3.75 3.75 0 0119.284 6.5H9.716zM22.5 15.808a2.25 2.25 0 00-1.692 1.692H22.5v-1.692zM6.5 8.19A2.249 2.249 0 008.192 6.5H6.5v1.691zM20.808 6.5c.19.84.851 1.5 1.692 1.691V6.5h-1.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.126 8.584a.75.75 0 011.248.832l-1.63 2.445a.25.25 0 000 .278l1.63 2.445.04.066a.75.75 0 01-1.242.827l-.046-.061-1.63-2.445a1.75 1.75 0 010-1.942l1.63-2.445z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_4143"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgMoneyBack.displayName = 'MoneyBack';
export default SvgMoneyBack;